import { ActionTree } from 'vuex';
import { State } from '@/store/modules/cloud/integrations/integrations.store';
import {
  GET_VENDOR,
  GET_INSTALLED_VENDORS,
  GET_ALL_PROJECTS,
  UPLOAD_PROJECT,
  SET_ALL_VENDORS,
  SET_INSTALLED_VENDORS,
  SET_ALL_PROJECTS,
  GET_AWS_ACCOUNTS,
  SET_AWS_ACCOUNTS,
  DELETE_AWS_ACCOUNT,
  DELETE_SET_AWS_ACCOUNTS,
} from '@/store/modules/cloud/integrations/integration.constants';
import { CloudService } from '@/services/api/integration.service';

export const actions: ActionTree<State, any> = {
  async [GET_VENDOR]({ commit }) {
    try {
      const { data } = await CloudService.getAllVendors();
      if (data.success === true) commit(SET_ALL_VENDORS, data.vendors);
      else commit(SET_ALL_VENDORS, {});
    } catch (error) {
      console.log('error', error);
      commit(SET_ALL_VENDORS, {});
    }
  },
  async [GET_INSTALLED_VENDORS]({ commit }) {
    try {
      const { data } = await CloudService.getInstalledVendors();
      if (data.success === true) commit(SET_INSTALLED_VENDORS, data.vendors);
      else commit(SET_INSTALLED_VENDORS, {});
    } catch (error) {
      console.log('error', error);
      commit(SET_INSTALLED_VENDORS, {});
    }
  },
  async [GET_ALL_PROJECTS]({ commit }, params) {
    try {
      const { data } = await CloudService.getAllProjects(params);
      if (data.success === true) commit(SET_ALL_PROJECTS, data.projects);
      else commit(SET_ALL_PROJECTS, {});
    } catch (error) {
      console.log('error', error);
      commit(SET_ALL_PROJECTS, {});
    }
  },
  async [UPLOAD_PROJECT]({ commit }, params) {
    const { data } = await CloudService.uploadProject(params);
    // if(data.success===true)
    // commit('setAllProjects',data.projects);
    // else
    //  commit('setAllProjects',{});
  },

  async [GET_AWS_ACCOUNTS]({ commit }) {
    try {
      const { data } = await CloudService.getAwsAccounts();
      if (data.success === true) {
        commit(SET_AWS_ACCOUNTS, data.awsAccounts);
      } else {
        commit(SET_AWS_ACCOUNTS, {});
      }
    } catch (error) {
      commit(SET_AWS_ACCOUNTS, {});
    }
  },

  async [DELETE_AWS_ACCOUNT]({ commit }, subscriptionId) {
    try {
      const response = await CloudService.deleteAwsAccount(subscriptionId);
      // Assuming your API returns a success response without specific data
      if (response.data.success) {
        commit(DELETE_AWS_ACCOUNT, subscriptionId);
      } else {
        // Handle error or non-successful response if needed
        throw new Error('Failed to delete AWS account');
      }
    } catch (error) {
      console.error('Error fetching AWS accounts:', error);
      commit(DELETE_SET_AWS_ACCOUNTS, {});
    }
  },
};

export default actions;
